import React, { useEffect, useMemo } from "react";
import FormBuilder from "../form_components/FormBuilder";
import MultiSelect, { SelectionOption } from "../form_components/MultiSelect";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { fetchEventTypes } from "../../features/Actions/ActionSlice";

export default function AvailableActions() {
    const dispatch = useAppDispatch();
    const eventtypes = useAppSelector(state => state.Actions.eventtypes);
    const current_project = useAppSelector(state => state.Projects.current_project);

    useEffect(() => {
        dispatch(fetchEventTypes());
    }, [dispatch]);

    const options: SelectionOption[] = eventtypes.map(eventType => ({
        option: eventType.name,
        enabled: Boolean(eventType.enabled)
    }));

    const preSelected = options
        .filter(option => option.enabled !== false)
        .map(option => option.option)
        .join(",");

    const formKey = useMemo(() => {
        return eventtypes.map(et => `${et.name}:${et.enabled}`).join("|");
    }, [eventtypes]);

    const onSubmit = () => {
        dispatch(fetchEventTypes());
    };

    if (!current_project || eventtypes.length === 0) return <div>Loading...</div>;

    return (
        <FormBuilder
            key={formKey}
            title="Available Actions"
            post="/events/eventtypes/ChangeAvailability"
            onSubmit={onSubmit}
            initialValues={{
                "Available Actions": preSelected
            }}
        >
            <MultiSelect name="Available Actions" options={options} />
        </FormBuilder>
    );
}
